import type { TransferData } from '../../constants'
import { cleanText, firstText, normalizeDate, normalizeDescriptionText, parseDescriptionFromHtml, readMeta } from '../../utils/parser'

function readWorkInfoValue (labels: string[]): string {
  for (const row of Array.from(document.querySelectorAll<HTMLElement>('.c-work_info dl, #anchor_info dl'))) {
    const label = cleanText(row.querySelector<HTMLElement>('dt')?.textContent || '').replace(/[:：]$/, '')
    if (!labels.includes(label)) continue

    const value = cleanText(row.querySelector<HTMLElement>('dd')?.textContent || '')
    if (value) return value
  }

  return ''
}

function parseTitle (): string {
  return firstText(['.c-detail_title .title', 'h1.title', '.c-work_info dt + dd span', 'h1']) || readMeta('og:title').replace(/\s+-\s+ちるちる$/, '') || 'book'
}

function parseOriginalTitle (): string {
  return firstText(['.c-detail_title .lang'])
}

function parseAuthor (): string {
  return readWorkInfoValue(['著者']) || firstText(['.c-basicdata01 a[href*="/authorDetail/"]'])
}

function parseIsbn (): string {
  const value = readWorkInfoValue(['ISBN'])
  return value.replace(/[^0-9X]/gi, '')
}

function parseFormat (): string {
  const medium = readWorkInfoValue(['媒体']).toLowerCase()
  if (medium.includes('小説')) return 'paperback'
  if (medium.includes('コミック') || medium.includes('漫画')) return 'paperback'
  if (medium.includes('blcd') || medium.includes('cd')) return 'audio'
  if (medium.includes('電子')) return 'digital'
  return ''
}

function parseDescription (): string {
  const synopsis = document.querySelector<HTMLElement>('.c-synopsis_text, .c-synopsis .js-text_cont')
  if (synopsis) {
    const value = parseDescriptionFromHtml(synopsis.innerHTML)
    if (value) return value
  }

  return normalizeDescriptionText(readMeta('description', 'og:description'))
}

function parseCoverUrl (): string {
  const image = document.querySelector<HTMLImageElement>('.c-cover01_thm img[itemprop="image"], .c-cover01 img, img[itemprop="image"]')
  const value = image?.src || readMeta('og:image')
  if (value.startsWith('//')) return `${window.location.protocol}${value}`
  if (value.startsWith('/')) return `${window.location.origin}${value}`
  return value
}

export function parseChilchilPage (): TransferData {
  return {
    title: parseTitle(),
    originalTitle: parseOriginalTitle(),
    author: parseAuthor(),
    language: 'Japanese',
    publisher: readWorkInfoValue(['出版社']),
    isbn: parseIsbn(),
    pages: '',
    pubDate: normalizeDate(readWorkInfoValue(['発売日'])),
    format: parseFormat(),
    desc: parseDescription(),
    rating: '',
    review: '',
    coverUrl: parseCoverUrl()
  }
}
